<app-header-navbar [sidenav]="sidenav" [mobileQuery]="mobileQuery" [userInfo]="globalUserInfo"
    (profileAction)="onProfileAction($event)">
</app-header-navbar>

<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav [mode]="!!mobileQuery && mobileQuery.matches ? 'over' : 'side'"
        [opened]="!!mobileQuery && !mobileQuery.matches" class="mat-elevation-z4">
        <app-side-navbar [isDay]="isDay" [menuData]="userMenu" [sidenav]="sidenav" [userInfo]="globalUserInfo"
            [isMenuOpened]="!!mobileQuery && !mobileQuery.matches" (profileAction)="onProfileAction($event)">
        </app-side-navbar>
    </mat-sidenav>

    <mat-sidenav-content>
        <ngx-simplebar>
            <router-outlet></router-outlet>
        </ngx-simplebar>
    </mat-sidenav-content>
</mat-sidenav-container>